<template>
  <div class="modal-dim on">
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal arc-modal">
          <!-- 상단 경고 아이콘 -->
          <div class="arc-icon-wrap">
            <div class="arc-icon-bg">
              <svg class="arc-warning" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 3.5 L21 19 H3 Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/>
                <path d="M12 10 V14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
                <circle cx="12" cy="16.7" r="1.05" fill="currentColor"/>
              </svg>
            </div>
          </div>

          <!-- 타이틀 -->
          <h1 class="arc-title">
            업종에 따라 광고가 <span class="arc-accent">제한</span>될 수 있어요
          </h1>
          <p class="arc-subtitle">다음 업종은 사전 고지 없이 광고가 중지될 수 있습니다.</p>

          <div class="arc-divider"></div>

          <!-- 업종 그리드 -->
          <div class="arc-grid">
            <div
              v-for="(item, idx) in items"
              :key="idx"
              class="arc-item"
            >
              <div class="arc-item-icon" v-html="item.icon"></div>
              <div class="arc-item-label" v-html="item.label"></div>
            </div>
          </div>

          <!-- 정책 안내 배너 -->
          <div class="arc-info">
            <svg class="arc-info-ico" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
              <path d="M12 11 V16.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="12" cy="7.8" r="1.05" fill="currentColor"/>
            </svg>
            <span>정책 관련 자세한 내용은 고객센터에서 확인하실 수 있습니다.</span>
          </div>

          <!-- 확인 버튼 -->
          <button type="button" class="arc-cta" @click="close">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['close']);

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 100);
};

const items = [
  {
    label: '도박 · 사행성 관련업',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="7" r="3.2" stroke="currentColor" stroke-width="1.8"/>
      <circle cx="7.2" cy="15.2" r="3.2" stroke="currentColor" stroke-width="1.8"/>
      <circle cx="16.8" cy="15.2" r="3.2" stroke="currentColor" stroke-width="1.8"/>
    </svg>`
  },
  {
    label: '다단계',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 19 L13.5 10.5 L17 14 L19.5 11.5 L13.5 5.5 L10.5 8.5 L4 15 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M14 7 L17 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`
  },
  {
    label: '성인용 게임장, 성인오락실',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="8.2" r="3.4" stroke="currentColor" stroke-width="1.8"/>
      <path d="M5 20 C5 16 8 14 12 14 C16 14 19 16 19 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>`
  },
  {
    label: '흥신소, 신용조사 및<br/>추심대행업',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 14.5 L3.5 9.5 L9 9.5 L15 5 L15 19 L9 14.5 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M17.5 9 C19 10.5 19 13.5 17.5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M19.5 7 C22 9.5 22 14.5 19.5 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`
  },
  {
    label: '성인용품',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
      <text x="12" y="15.3" text-anchor="middle" font-family="Pretendard, -apple-system, sans-serif" font-size="8.5" font-weight="700" fill="currentColor">19</text>
    </svg>`
  },
  {
    label: '유흥주점업',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 9 L4 7 L20 7 L20 9 L18.5 11 L5.5 11 Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M5.5 11 L5.5 20 L18.5 20 L18.5 11" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M10 20 L10 14.5 L14 14.5 L14 20" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
    </svg>`
  },
  {
    label: '불건전 오락기구 관련업',
    icon: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="3.4" stroke="currentColor" stroke-width="1.8"/>
      <path d="M12 3.5 V6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M12 18 V20.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M3.5 12 H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M18 12 H20.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M6 6 L7.8 7.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M16.2 16.2 L18 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M18 6 L16.2 7.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M7.8 16.2 L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>`
  }
];
</script>

<style scoped lang="scss">
$arc-red: #FF1F1F;
$arc-red-soft: #FEE2E2;
$arc-text: #1A1A1A;
$arc-text-sub: #8A8F98;
$arc-divider: #EEEFF1;
$arc-info-bg: #F4F5F7;
$arc-info-text: #8A8F98;

.modal-dim.on {
  position: fixed;
  inset: 0;
  background: rgba(17, 17, 17, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

.modal-inner.center {
  width: 100%;
  max-width: 360px;
  padding: 0 20px;
}

.arc-modal {
  background: #FFFFFF;
  border-radius: 24px;
  padding: 32px 22px 22px;
  box-shadow: 0 20px 48px rgba(17, 17, 17, 0.12);
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  color: $arc-text;
}

/* 상단 경고 아이콘 */
.arc-icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
}
.arc-icon-bg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: $arc-red-soft;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $arc-red;
}
.arc-warning {
  width: 34px;
  height: 34px;
}

/* 타이틀 */
.arc-title {
  font-size: 19px;
  font-weight: 800;
  text-align: center;
  line-height: 1.45;
  letter-spacing: -0.02em;
  margin: 0 0 8px;
  color: $arc-text;
}
.arc-accent {
  color: $arc-red;
}
.arc-subtitle {
  font-size: 13.5px;
  text-align: center;
  color: $arc-text-sub;
  margin: 0 0 20px;
  line-height: 1.5;
  letter-spacing: -0.01em;
}

.arc-divider {
  height: 1px;
  background: $arc-divider;
  margin: 0 0 20px;
}

/* 업종 그리드 */
.arc-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 14px;
  margin-bottom: 20px;
}
/* 컬럼 사이 세로 디바이더 */
.arc-grid::before {
  content: '';
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 50%;
  width: 1px;
  background: $arc-divider;
  transform: translateX(-0.5px);
}
.arc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
}
/* 좌측 컬럼은 디바이더 왼쪽 여백 확보, 우측 컬럼은 디바이더 오른쪽 여백 */
.arc-item:nth-child(odd) {
  padding-right: 6px;
}
.arc-item:nth-child(even) {
  padding-left: 6px;
}
.arc-item-icon {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: $arc-red-soft;
  color: $arc-red;
  display: flex;
  align-items: center;
  justify-content: center;
}
.arc-item-icon :deep(svg) {
  width: 24px;
  height: 24px;
}
.arc-item-label {
  font-size: 13px;
  font-weight: 600;
  color: $arc-text;
  line-height: 1.35;
  letter-spacing: -0.02em;
  word-break: keep-all;
}

/* 정책 안내 배너 */
.arc-info {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: $arc-info-bg;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  color: $arc-info-text;
  font-size: 12.5px;
  line-height: 1.45;
  letter-spacing: -0.01em;
}
.arc-info-ico {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 1px;
}

/* 확인 버튼 */
.arc-cta {
  width: 100%;
  height: 56px;
  border: 0;
  border-radius: 14px;
  background: $arc-red;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  cursor: pointer;
}
.arc-cta:active {
  background: #E51A1A;
}
</style>
